import script from "./DateChanger.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateChanger.vue?vue&type=script&setup=true&lang=ts"

import "./DateChanger.vue?vue&type=style&index=0&id=476dc477&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-476dc477"]])

export default __exports__